import { render, staticRenderFns } from "./ModalPadrao.vue?vue&type=template&id=78bb7402&"
import script from "./ModalPadrao.vue?vue&type=script&lang=js&"
export * from "./ModalPadrao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports